import React, {Component} from "react";
import {connect} from "react-redux";
import {withTranslation} from "react-i18next";
import {compose} from "redux";
import ModalHeader from "../ModalHeader";
import ModalBody from "../ModalBody";
import ModalFooter from "../ModalFooter";
import {Modal} from "react-bootstrap";
import {connectModal} from "redux-modal";
import {Field, FormSection, reduxForm} from "redux-form";
import ReduxLabeledInput from "../../basics/input/labeled-input/ReduxLabeledInput";
import {
    convertWeightToBaseUnit,
    convertWeightUnitTo,
    getUnit,
} from "../../../utils/UnitUtils";
import {UnitTypes} from "../../../constans/unitTypes";
import {submit, validate} from "./EditWeightingModalSubmit";
import moment from "moment";
import ConfirmModificationField from "../../custom-fields/ConfirmModificationField";
import memoizeOne from "memoize-one";
import animalsDB from "../../../database/animalsDB";

function mapStateToProps(state) {
    return {};
}

export const ModalName = "edit-weighting";

class EditWeightingModal extends Component {
    constructor(props) {
        super(props);
        const copy = JSON.parse(JSON.stringify(this.props.event));
        delete copy.$loki;
        this.props.initialize(copy);
    }

    canEditAnimalCount = memoizeOne(() => {
        const {animal, event} = this.props;
        if (animal) return false;
        if (event.AnmCnt > 1) return true;
        const groupAnimal = animalsDB.getAnimalById(event.AnmID, {
            joinEvents: false,
            findDeleted: true,
        });
        if (!groupAnimal) return false;
        return !(groupAnimal.RFID || groupAnimal.Tagged);
    });

    render() {
        const {show, handleHide, submitting, t, group, animal} = this.props;
        const canEditAnmCnt = this.canEditAnimalCount();
        return (
            <Modal show={show} size={"lg"}>
                <ModalHeader
                    title={t("apiNotifications.updateWeightingTitle")}
                    onCloseClick={handleHide}
                />
                <ModalBody>
                    <Field
                        name={"EvTime"}
                        component={ReduxLabeledInput}
                        label={t("date")}
                        type={"date"}
                        format={(value) =>
                            value
                                ? moment(value).format(moment.HTML5_FMT.DATE)
                                : ""
                        }
                        parse={(value) => (value ? +moment(value) : null)}
                    />
                    {canEditAnmCnt && (
                        <Field
                            name={"AnmCnt"}
                            component={ReduxLabeledInput}
                            label={t("animalCount")}
                            type={"number"}
                        />
                    )}
                    <FormSection name="EvData">
                        <Field
                            name={"Weight"}
                            component={ReduxLabeledInput}
                            label={t("weight")}
                            type={"number"}
                            unit={getUnit("weight", UnitTypes.MEDIUM)}
                            format={(value) =>
                                value
                                    ? convertWeightUnitTo(+value, {
                                          unit: UnitTypes.MEDIUM,
                                          rawValue: true,
                                          fixed: 1,
                                      })
                                    : null
                            }
                            parse={(value) =>
                                value
                                    ? convertWeightToBaseUnit(+value, {
                                          fromUnit: UnitTypes.MEDIUM,
                                      })
                                    : null
                            }
                        />
                    </FormSection>
                    <ConfirmModificationField
                        group={!!group}
                        name={group ? group.GrNo1 : animal?.AnmNo1}
                    />
                </ModalBody>
                <ModalFooter
                    hasConfirmButton
                    confirmText={t("save")}
                    onCloseClick={handleHide}
                    formName={ModalName}
                    submitting={submitting}
                />
            </Modal>
        );
    }
}

export default compose(
    withTranslation(),
    connect(mapStateToProps),
    connectModal({name: ModalName}),
    reduxForm({
        form: ModalName,
        onSubmit: submit,
        validate,
    })
)(EditWeightingModal);
